export default {"src":"/_next/static/media/groupBlue.d78f90da.svg","height":48,"width":49,"blurWidth":0,"blurHeight":0};